import { z } from "zod";

export const oauthClientResponseSchema = z.object({
  client_id: z.string(),
  name: z.string(),
  description: z.string(),
  url: z.string(),
  logo: z.string().optional(),
  terms_of_use: z.string(),
  privacy_policy: z.string(),
  // The legacy type declared `status` via an empty enum, which resolves to
  // `never`. Model it as a string so the runtime value is retained.
  status: z.string(),
  client_secret: z.string().optional(),
  redirect_uri: z.array(z.string()).nullish(),
  live_trading_approved: z.boolean(),
  screenshots: z.array(z.string()).nullish(),
  categories: z.array(z.string()).nullable(),
  built_by_alpaca: z.boolean(),
  featured: z.boolean(),
  public: z.boolean(),
  ria: z.boolean(),
});

export const oauthClientByIdResponseSchema = z.object({
  client_id: z.string(),
  name: z.string(),
  description: z.string(),
  url: z.string(),
  terms_of_use: z.string(),
  privacy_policy: z.string(),
  logo: z.string(),
  status: z.string(),
  extension: z.object({
    built_by_alpaca: z.boolean(),
    featured: z.boolean(),
    public: z.boolean(),
    screenshots: z.array(z.string()),
    categories: z.array(z.string()),
  }),
  created_at: z.string(),
  updated_at: z.string(),
  deleted_at: z.any(),
});

export const getOAuthTokensResponseSchema = z.object({
  client_id: z.string(),
  owner_id: z.string(),
  id: z.string(),
  created_at: z.string(),
  live_account_id: z.string().nullish(),
  paper_account_id: z.string().nullish(),
  status: z.string(),
});
